import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Mousewheel, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import styles from "./Css/GarhwaliCarousel.module.css";
import { useAudiosByLanguage } from "../../hooks/useAudiosHooks";
import { useNavigate } from "react-router-dom";

const GarhwaliCarousel = ({ language }) => {
  const {
    data: audiosData,
    isLoading,
    isError
  } = useAudiosByLanguage(language, {
    limit: 10,
    offset: 0,
    sort_by: "created_at",
    sort_order: "DESC"
  });
  const navigate = useNavigate();

  if (isLoading || isError || !audiosData?.data?.length) return null;

  const audios = audiosData.data.slice(0, 10);

  return (
    <div className={styles.carouselContainer}>
      <h2 className={styles.title}>Garhwali</h2>
      <Swiper
        modules={[Mousewheel, FreeMode, Navigation]}
        mousewheel={{ forceToAxis: true }}
        freeMode
        slidesPerView={3}
        spaceBetween={15}
        navigation
        breakpoints={{
          768: { slidesPerView: 5, spaceBetween:10 },
          320: { slidesPerView: 3, spaceBetween: 10 },
           1200: { slidesPerView: 7, spaceBetween: 20 },

        }}
        className={styles.swiper}
      >
        {audios.map((audio) => (
          <SwiperSlide key={audio.id} className={styles.slide}>
            <div className={styles.card}>
              <img
                src={audio.mobile_image_url}
                alt={audio.title}
                className={styles.image}
                onClick={()=>navigate(`/audio-play/${audio.slug}`)}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default GarhwaliCarousel;
